import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://get-3p45.onrender.com/get/api'
});

export default api;
